import { getUserFields } from "components/user/config";
import { getItemFromCollection } from "directus/src/operations";

export async function fetchOpeningApplicantDataforForm({ id }) {
  try {
    const query = {
      fields: [
        "id",
        getUserFields("employee"),
        "experience",
        "description",
        "resume_url",
        "is_selected",
      ],
    };
    const response = await getItemFromCollection("opening_applicants", id, query);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
